export const endpoints = {
    kpiScoreMetadata: 'analyze/company/companyUUID/kpi-score-metadata/',
}
